<template>
  <div v-if="show" class="ip" role="dialog" aria-label="Instalar la app">
    <img class="ip-i" src="/img/icons/android-chrome-192x192.png" alt="" width="44" height="44">
    <div class="ip-t">
      <b>Instala {{ appName }} en tu celular</b>
      <span v-if="ios">Toca <b>Compartir</b> <span aria-hidden="true">⬆️</span> y luego <b>Agregar a inicio</b>.</span>
      <span v-else>Se abre como app, sin barra del navegador.</span>
    </div>
    <button v-if="!ios" type="button" class="ip-b" @click="install">Instalar</button>
    <button type="button" class="ip-x" aria-label="Cerrar" @click="dismiss">✕</button>
  </div>
</template>

<script>
const KEY = 'festyInstallDismissed'
const DAYS = 14

export default {
  name: 'InstallPrompt',
  props: { appName: { type: String, default: 'Festy' } },
  data: () => ({ deferred: null, ios: false, hidden: true }),
  computed: { show () { return !this.hidden } },
  mounted () {
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
    if (standalone || this.recentlyDismissed()) return
    const ua = window.navigator.userAgent
    this.ios = /iphone|ipad|ipod/i.test(ua) && !window.MSStream
    if (this.ios) {
      // en iPhone solo Safari puede instalar; otros navegadores no muestran el aviso
      if (/crios|fxios|edgios|opios/i.test(ua)) return
      this.hidden = false
    }
    window.addEventListener('beforeinstallprompt', this.onPrompt)
    window.addEventListener('appinstalled', this.dismiss)
  },
  beforeDestroy () {
    window.removeEventListener('beforeinstallprompt', this.onPrompt)
    window.removeEventListener('appinstalled', this.dismiss)
  },
  methods: {
    recentlyDismissed () {
      try {
        const t = Number(window.localStorage.getItem(KEY))
        return t && Date.now() - t < DAYS * 86400000
      } catch (e) { return false }
    },
    onPrompt (e) {
      e.preventDefault()
      this.deferred = e
      this.hidden = false
    },
    async install () {
      if (!this.deferred) return
      this.deferred.prompt()
      await this.deferred.userChoice
      this.deferred = null
      this.dismiss()
    },
    dismiss () {
      this.hidden = true
      try { window.localStorage.setItem(KEY, String(Date.now())) } catch (e) { /* sin almacenamiento */ }
    }
  }
}
</script>

<style scoped>
.ip { position: fixed; left: 12px; right: 12px; bottom: 12px; z-index: 50; display: flex; align-items: center; gap: 12px; max-width: 520px; margin: 0 auto; padding: 12px 14px; border-radius: 16px; background: #16150f; color: #fff; box-shadow: 0 8px 30px rgba(0, 0, 0, .35); font-family: 'Onest', system-ui, sans-serif; }
.ip-i { border-radius: 10px; flex: none; }
.ip-t { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; font-size: 14px; line-height: 1.3; }
.ip-t b { font-size: 15px; }
.ip-b { flex: none; min-height: 44px; padding: 0 18px; border: 0; border-radius: 12px; background: #f3d923; color: #16150f; font: inherit; font-weight: 700; cursor: pointer; }
.ip-x { flex: none; width: 44px; height: 44px; border: 0; background: transparent; color: #cfcab0; font-size: 18px; cursor: pointer; }
</style>
